import React, { memo } from "react";
const OptionMenu = ({ className, option, isFocused, selectedOption, isDisabled, }) => {
    const additionalProps = {
        focus: isFocused ? "" : undefined,
        disabled: isDisabled,
    };
    return (React.createElement("div", { className: className, onMouseDown: (e) => {
            if (isDisabled) {
                e.preventDefault();
            }
            else {
                selectedOption(option);
            }
        }, ...additionalProps }, option.label));
};
export default memo(OptionMenu);
